
<div class="dashboard-content-sec">
    <div class="card mb-0">
        <app-breadcrumb *ngIf="!embedded" [crumbList] = "crumbList"></app-breadcrumb>
        <div class="user-heading-sec">
            <div class="mr-4 d-inline-block">
                <a data-toggle="collapse" *ngIf="embedded" id="roleprofile-expand" 
                    style="width:180px" class="p-2 fa fa-expand-alt" 
                    href="#roleProfileTable" > 
                    <!-- (click)="swapIcon($event)"> -->
                        {{this.total}} Role Profiles</a>
                <span *ngIf="!embedded" id="roleprofile-expand" class="p-2" href="#">
                        {{this.total}} Role Profiles</span>
            </div>
 
            <div style='width: 120px' class="d-inline-block">
                <a *ngIf="embedded" data-toggle="collapse" href="#newRoleProfile" 
                    class="fa fa-user-circle btn btn-default ">
                    Add Role Profile
                </a>                        
                <a *ngIf="!embedded" href="javascript:void(0)" [routerLink]="['/admins/roleprofile']" 
                    class="btn btn-default fa fa-user-circle">
                    Add Role Profile
                </a>     
            </div>  

            <div *ngIf='embedded' id="newRoleProfile" class="collapse mt-3">
                <app-roleprofile [roleprofile_id]="0" [client_id]="client_id" 
                    [partner_id]="partner_id" (submit_return)="collapseRoleProfile()"> 
                </app-roleprofile>
            </div>                   
            
        </div>

        <div id="roleProfileTable" class="table-responsive" [ngClass]="{'collapse': embedded}">
          <div class="loader" *ngIf="showloader">
            <img src="assets/images/loader.gif" alt="">
          </div>
            <table class="table user-table table-striped" >
                <thead>
                    <tr>
                        <th *ngFor="let header of row_header;let i = index" (click)="tableSort(i)">
                            <i *ngIf="header.sort == 'asc' && header.value != ''" class="fa fa-sort-up"></i>
                            <i *ngIf="header.sort == 'desc' && header.value != ''" class="fa fa-sort-down"></i>
                            <i *ngIf="header.sort == null && header.value != ''" class="fa fa-sort"></i> {{header.text}}
                        </th>
                      <th>Restricted</th>
                      <th>Delete</th>
                    </tr>
                    <tr *ngIf="!embedded">
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByClient($event)"/>
                            </div>
                        </th>
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByName($event)"/>
                            </div>
                        </th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let role of roleprofiles">
                        <tr>
                        
                            <td *ngIf="role.Role != 3">
                                <a *ngIf="!embedded" href="javascrpt:void(0);" [routerLink]="['/admins/roleprofile',role.ID]">
                                    {{role.client?.ClientName ? role.client?.ClientName : '-'}}
                                </a>
                                <a *ngIf="embedded" data-toggle="collapse" (click)="scrollView($event, role.ID)" href="#roleProfileEdit{{role.ID}}">
                                    {{role.client?.ClientName ? role.client?.ClientName : '-'}}
                                </a>
                            </td>

                            <td *ngIf="role.Role === 3">
                                <a *ngIf="!embedded" href="javascrpt:void(0);" [routerLink]="['/admins/roleprofile',role.ID]">
                                    {{role.partner?.CompanyName ? role.partner?.CompanyName : '-'}}
                                </a>
                                <a *ngIf="embedded" data-toggle="collapse" (click)="scrollView($event, role.ID)" href="#roleProfileEdit{{role.ID}}">
                                    {{role.partner?.CompanyName ? role.partner?.CompanyName : '-'}}
                                </a>
                            </td>
                            
                            <td>
                                <a *ngIf="!embedded" href="javascrpt:void(0);" [routerLink]="['/admins/roleprofile',role.ID]">
                                    {{role.Name }}
                                </a>
                                <a *ngIf="embedded" data-toggle="collapse" (click)="scrollView($event, role.ID)" href="#roleProfileEdit{{role.ID}}">
                                    {{role.Name }} 
                                </a>
                            </td>

                            <td>
                                <a *ngIf="!embedded" href="javascrpt:void(0);" [routerLink]="['/admins/roleprofile',role.ID]">
                                    {{role.RoleTypeName }}
                                </a>
                                <a *ngIf="embedded" data-toggle="collapse" (click)="scrollView($event, role.ID)" href="#roleProfileEdit{{role.ID}}">
                                    {{role.RoleTypeName }} 
                                </a>
                            </td>

                            <td>
                                {{role.RestrictedAccess === 1 ? 'Yes' : ''}}
                            </td>

                            <td>
                                <div class="d-inline-block">
                                    <a title="Delete" class="btn fa fa-times" (click)="deleteRoleProfile(role.ID)"> </a>
                                </div>
                            </td>
                        </tr>
                        <tr class="h-0">
                            <td colspan="6" class="p-0 m-0">
                                <div *ngIf="embedded" id="roleProfileEdit{{role.ID}}" class="collapse user_edit">
                                    <app-roleprofile [roleprofile_id]="role.ID" [client_id]="client_id" [partner_id]="partner_id"
                                       (submit_return)="collapseRoleProfile()"></app-roleprofile>
                                </div>
                            </td>
                        </tr>
                        <tr class="h-0"></tr>                    

                    </ng-container>
                </tbody>

                <ng-container *ngIf="roleprofiles?.length == 0">
                  <tr><td colspan="6">No Result Found</td></tr>
                </ng-container>



            </table>
            <div class="has-text-centered align-items-end">
                <ul *ngIf="pager.pages && pager.pages.length && pager.pages.length>1" class="pagination">
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(1)">First</a>
                    </li>
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(pager.currentPage - 1)">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="setPage(page)">{{page}}</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.currentPage + 1)">Next</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.totalPages)">Last</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
